var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["detailed-description", { mobile: _vm.isMobile(_vm.$mq) }] },
    [
      _vm.course.description
        ? _c("div", { staticClass: "section description" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Course description")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "text-container",
              domProps: { innerHTML: _vm._s(_vm.course.description.head) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.course.concepts_include.length
        ? _c("div", { staticClass: "section concepts" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Topics covered")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "two-columns" },
              _vm._l(_vm.course.concepts_include, function(concept) {
                return _c("li", { key: concept, staticClass: "text" }, [
                  _vm._v("\n        " + _vm._s(concept) + "\n      ")
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.course.prereqs_and_next_steps
        ? _c("div", { staticClass: "section prerequisites-and-next-steps" }, [
            _c("h4", { staticClass: "title" }, [
              _vm._v("Prerequisites and next steps")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "text-container",
              domProps: { innerHTML: _vm._s(_vm.course.prereqs_and_next_steps) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.course.course_map && _vm.course.course_map.prerequisites.length
        ? _c("div", { staticClass: "section prerequisite-courses" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Prerequisites")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "courses-container" },
              _vm._l(_vm.course.course_map.prerequisites, function(
                prerequisite
              ) {
                return _c(
                  "li",
                  { key: prerequisite.course_id, staticClass: "course" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href: prerequisite.absolute_url,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(prerequisite.name) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.course.course_map && _vm.course.course_map.next_steps.length
        ? _c("div", { staticClass: "section next-courses" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("Next steps")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "courses-container" },
              _vm._l(_vm.course.course_map.next_steps, function(nextStep) {
                return _c(
                  "li",
                  { key: nextStep.course_id, staticClass: "course" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: { href: nextStep.absolute_url, target: "_blank" }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(nextStep.name) + "\n        "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }